import type { SolutionSector } from "../sectors";
import { ACCESS_QUESTION, COST_QUESTION, EFFORT_QUESTION, HOSTING_QUESTION, LOGO } from "./shared";

export const FOOD_CONSUMER_GOODS: SolutionSector = {
  slug: "fmcg",
  name: "Food & consumer goods",
  demoOrg: "Demo (FMCG)",
  story: "food",
  metadata: {
    title: "AI for product launch reviews | Your Twin",
    description:
      "See missing supplier documents and open questions before each launch review. Your Twin connects Google Sheets, Google Drive, Xero and Outlook.",
  },
  hero: {
    label: "Food & consumer goods",
    title: ["Complete the", "file for every", "food launch."],
    lead: [
      "Your Twin connects launch trackers in ",
      LOGO.sheets,
      " with specifications in ",
      LOGO.drive,
      ", supplier bills in ",
      LOGO.xero,
      " and replies in ",
      LOGO.outlook,
      ", so you see what each launch is still missing before the review.",
    ],
    cta: "Bring a launch checklist",
    buyer: "For NPD, technical, operations and supply chain directors",
    instrumentLabel: "The launch Twin · Product, document, supplier and owner",
  },
  replay: {
    title: "What’s still missing\nfor next month’s launch?",
    lead: "Ask across the launch plan, the documents and the supplier replies. See each outstanding item beside its launch date and owner.",
  },
  outcomes: {
    title: "Every launch document\nin view.",
    lead: "The launch team sees what each supplier still owes and who is chasing it.",
    items: [
      { title: "Find the missing launch document.", body: "Compare the checklist with the connected supplier records.", show: "status" },
      { title: "Keep specifications in view.", body: "See which revision the review is using.", show: "sources" },
      { title: "Prepare the supplier follow-up.", body: "Bring the open question and recorded owner together.", show: "owners" },
    ],
  },
  start: { firstStep: "Choose a launch checklist that is hard to keep complete." },
  questions: [
    { q: "Does it certify quality or food safety?", a: "No. It organises the evidence for review. Qualified people make those decisions." },
    {
      q: "Will it notice a report for the wrong batch?",
      a: "When the batch or revision is recorded in the document, the review shows which one it uses, so a mismatch is visible to your team.",
    },
    ACCESS_QUESTION,
    HOSTING_QUESTION,
    EFFORT_QUESTION,
    COST_QUESTION,
  ],
  closing: "Start with one launch checklist\nthat is never quite complete.",
};
